module.exports = __webpack_public_path__ + "static/img/stripe@3x.12c25097.png";